import React from 'react';
import Breadcrumbs from './index';
import PropTypes from 'prop-types';
import { toKebabCase } from '@leadhome/utils';
import { BreadcrumbsWrapper } from 'styles';
import useLocationlessQuery from 'utils/hooks/use-locationless-query';
import { defaultPropertyTypeInfo, propertyTypeMap } from 'utils/property';

const SearchPageBreadCrumbs = ({ locations, propertyTypes }) => {
  let queryString = useLocationlessQuery();
  if (queryString) queryString = `?${queryString}`;

  const routes = getRoutes(locations, propertyTypes).map((r) => {
    const newRoute = { ...r };
    if (r.url && queryString) {
      newRoute.url += queryString;
    }

    return newRoute;
  });
  return (
    <BreadcrumbsWrapper>
      <Breadcrumbs routes={routes} />
    </BreadcrumbsWrapper>
  );
};

function getRoutes(locations, propertyType) {
  const routes = [];
  const propertyTypesAsArray = Array.isArray(propertyType)
    ? propertyType
    : [propertyType];

  routes.push(getRootBreadcrumbRoute(propertyTypesAsArray));
  routes.push(...getLocationBreadcrumbRoutes(locations, propertyTypesAsArray));
  return routes;
}
function getLocationBreadcrumbRoutes(locations, propertyTypes = []) {
  const routes = [];

  if (locations.length === 0) {
    return routes;
  } else if (locations.length === 1) {
    const location = locations[0];

    const locationRoutePrefix =
      propertyTypes.length !== 1
        ? defaultPropertyTypeInfo.locationLinkPrefix
        : propertyTypeMap[propertyTypes[0]].locationLinkPrefix;

    location.provinceId &&
      routes.push({
        name: location.province,
        url: `${locationRoutePrefix}/${toKebabCase(location.province)}/${
          location.provinceId
        }`
      });

    location.townId &&
      routes.push({
        name: location.town,
        url: `${locationRoutePrefix}/${toKebabCase(
          location.province
        )}/${toKebabCase(location.town)}/${location.townId}`
      });

    location.suburbId &&
      routes.push({
        name: location.suburb
      });
  } else {
    routes.push({
      name: 'Multiple areas'
    });
  }

  return routes;
}

function getRootBreadcrumbRoute(propertyTypes) {
  if (propertyTypes.length === 1) {
    const propertyTypeName = propertyTypes[0];
    return {
      name: propertyTypeMap[propertyTypeName]?.mainHeading,
      url: `${propertyTypeMap[propertyTypeName]?.locationLinkPrefix}`
    };
  } else {
    return {
      name: defaultPropertyTypeInfo.mainHeading,
      url: `${defaultPropertyTypeInfo.locationLinkPrefix}`
    };
  }
}

SearchPageBreadCrumbs.propTypes = {
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      province: PropTypes.string,
      provinceId: PropTypes.string,
      town: PropTypes.string,
      townId: PropTypes.string,
      suburb: PropTypes.string,
      suburbId: PropTypes.string,
      type: PropTypes.string
    })
  ),
  propertyTypes: PropTypes.arrayOf(PropTypes.string)
};

export default SearchPageBreadCrumbs;
